// For a field that is never the person's own details (a sensor's zip code, a
// note, a search): no browser suggestions, and the password managers
// (LastPass, 1Password, Bitwarden, Dashlane) leave it alone. Its name should
// not say "zip" or "address" either: browsers fill those from a saved address.
export const NO_FILL = 'autocomplete="off" data-lpignore="true" data-1p-ignore="true" data-bwignore="true" data-form-type="other"';
